;
;
export class ApiRequestStatus {
}
ApiRequestStatus.Pending = "ApiRequestStatus.Pending";
ApiRequestStatus.InProgress = "ApiRequestStatus.InProgress";
ApiRequestStatus.Complete = "ApiRequestStatus.Complete";
ApiRequestStatus.Error = "ApiRequestStatus.Error";
;
export class ApiRequestStatusSummary {
    constructor() {
        this.total = 0;
        this.numPending = 0;
        this.numInProgress = 0;
        this.numError = 0;
    }
    isFinished() {
        var result = (0 == this.numPending && 0 == this.numInProgress);
        return result;
    }
}
;
export var EntityMwimporterworkload_Status;
(function (EntityMwimporterworkload_Status) {
    EntityMwimporterworkload_Status["NOTSTARTED"] = "NOTSTARTED";
    EntityMwimporterworkload_Status["INPROGRESS"] = "INPROGRESS";
    EntityMwimporterworkload_Status["COMPLETE"] = "COMPLETE";
    EntityMwimporterworkload_Status["FAILED"] = "FAILED";
    EntityMwimporterworkload_Status["ORPHAN"] = "ORPHAN";
})(EntityMwimporterworkload_Status || (EntityMwimporterworkload_Status = {}));
